import type { UserDevice } from '@tunein/web-api-client';
import { createSelectorFunctions } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';

export interface UserState {
  devices: UserDevice[];
}

export interface UserActions {
  setDevices: (devices: UserDevice[]) => void;
  addDevice: (device: UserDevice) => void;
  removeDevice: (deviceId: number) => void;
}

export type UserStore = UserState & UserActions;
export type InitialUserState = Partial<UserState>;

const defaultState: UserState = {
  devices: [],
};

export function createUserStore(initialState: InitialUserState = {}) {
  const userStore = create<UserStore>((set) => ({
    ...defaultState,
    ...initialState,

    setDevices: (devices) => set({ devices }),
    addDevice: (device) => set((state) => ({ devices: [...state.devices, device] })),
    removeDevice: (deviceId) =>
      set((state) => ({
        devices: state.devices.filter((device) => device.id !== deviceId),
      })),
  }));

  return createSelectorFunctions(userStore);
}
